import React from "react";
import styled from "styled-components";

export default styled.section`
    width: 16.66%;
    float: left;
    font-size: 12px;
    text-align: center;
    height: 100px;
    cursor: pointer;
`;